import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

/** A failing screen shows a friendly card instead of blanking the whole app. */
export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Screen failed', error, info.componentStack);
  }

  override render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="mx-auto flex w-full max-w-xl flex-col gap-4 px-4 pt-safe pb-36 lg:pt-8">
        <section
          role="alert"
          className="card mt-4 flex flex-col items-center px-6 py-8 text-center"
        >
          <span className="grid h-14 w-14 place-items-center rounded-2xl bg-missed-soft text-missed-ink">
            <AlertTriangle size={28} />
          </span>
          <h2 className="mt-4 text-[19px] font-semibold">Ta zaslon se ni naložil</h2>
          <p className="mt-1 max-w-xs text-[15px] text-muted">
            Tvoji podatki so varni. Poskusi znova; če ne pomaga, osveži aplikacijo.
          </p>
          <div className="mt-5 flex gap-2">
            <button
              type="button"
              onClick={() => {
                this.setState({ error: null });
              }}
              className="tap min-h-11 rounded-full bg-surface-2 px-4 text-[15px] font-semibold"
            >
              Poskusi znova
            </button>
            <button
              type="button"
              onClick={() => {
                window.location.reload();
              }}
              className="tap inline-flex min-h-11 items-center gap-1.5 rounded-full bg-accent px-4 text-[15px] font-semibold text-on-accent"
            >
              <RefreshCw size={16} /> Osveži
            </button>
          </div>
        </section>
      </div>
    );
  }
}
